/* eslint-disable react/no-children-prop */
import { IconButton, Tooltip } from '@chakra-ui/react';
import { Trash } from 'phosphor-react';
import React from 'react';

export const DeleteButton = ({ onClick }: any) => {
  return (
    <Tooltip label="Excluir" openDelay={300}>
      <IconButton
        onClick={onClick}
        color="content.subtle"
        icon={<Trash size={16} />}
        size="xs"
        mr="2px"
        variant="ghost"
        _hover={{ bg: 'state.destructiveSurface', color: 'state.destructive' }}
        aria-label="Excluir"
      />
    </Tooltip>
  );
};
